import { registerSW } from "virtual:pwa-register";

type ServiceWorkerUpdatedDetail = {
  waiting: {
    postMessage: (message: { type?: string }) => void;
  };
};

declare global {
  interface DocumentEventMap {
    serviceWorkerUpdated: CustomEvent<ServiceWorkerUpdatedDetail>;
  }
}

export function registerPortalServiceWorker() {
  if (import.meta.env.DEV || !("serviceWorker" in navigator)) {
    return;
  }

  const updateServiceWorker = registerSW({
    immediate: true,
    onOfflineReady() {
      console.log("Content has been cached for offline use.");
    },
    onNeedRefresh() {
      console.log("New content is available; please refresh.");

      document.dispatchEvent(
        new CustomEvent("serviceWorkerUpdated", {
          detail: {
            waiting: {
              postMessage(message: { type?: string }) {
                if (message.type === "SKIP_WAITING") {
                  void updateServiceWorker(true);
                }
              },
            },
          },
        })
      );
    },
    onRegisterError(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
